module.exports = __webpack_public_path__ + "img/inco5.1339dad4.png";